import React from "react";
import CustomerInformation from "./companyDetails/CustomerInformation";
import CompanyContacts from "./companyDetails/CompanyContacts";
import CompanyData from "./companyDetails/CompanyData";

const CompanyDetailsTab = () => {
  return (
    <div>
      <CustomerInformation/>
      <CompanyContacts/>
      <CompanyData/>
    </div>
  );
};


export default CompanyDetailsTab;
